import React from 'react';
import '../ModalEditWindow.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeRequestModal } from '../../../actions/modals';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import { SetCity } from '../../../actions/li';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import MAIN_CITIES from '../../../constants/mainCities';
import { List, ListItem, ListItemText } from '@material-ui/core';

class ChooseCity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      find: '',
    };
  }

  chooseCity(el) {
    this.props.SetCity(el);
    this.props.closeRequestModal();
  }

  onChange = (e) => {
    this.setState({ find: e.target.value });
  };

  render() {
    let domain =
      document.location.hostname.split('.')[
        document.location.hostname.split('.').length - 1
      ];
    // domain = "by";
    const { t } = this.props;
    let obj =
      (this.props.cities.list && JSON.parse(this.props.cities.list)) || false;
    if (this.state.find)
      obj = obj.filter((el) =>
        el.title[domain]
          .toLocaleLowerCase()
          .includes(this.state.find.toLocaleLowerCase()),
      );
    return (
      <>
        <TextField
          type="text"
          label={t('form.search_city')}
          style={{ width: '100%' }}
          onChange={this.onChange}
        />
        <div className="cities_container">
          {obj ? (
            <List>
              {obj
                .sort((a, b) =>
                  a.title[domain] > b.title[domain]
                    ? 1
                    : a.title[domain] < b.title[domain]
                    ? -1
                    : 0,
                )
                .map((el, index) => {
                  return (
                    <ListItem
                      button
                      className={`${
                        MAIN_CITIES.includes(el.program_title)
                          ? 'cities_title main_city'
                          : 'cities_title'
                      }`}
                      key={index}
                      onClick={() => this.chooseCity(el)}
                    >
                      <ListItemText primary={el.title[domain]} />
                    </ListItem>
                  );
                })}
            </List>
          ) : (
            <Box pt={1}>
              <CircularProgress />
            </Box>
          )}
        </div>
      </>
    );
  }
}

const withForm = connect(
  (state) => ({ cities: state.cities }),
  (dispatch) =>
    bindActionCreators(
      {
        SetCity,
        closeRequestModal,
      },
      dispatch,
    ),
);

export default withTranslation()(withForm(ChooseCity));
